import React from "react";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import Slider from "react-slick";
import "./DownloadBanner.css";
// import finqImage from '../../../images/finqImage.png';
import downloadbanner from '../../../images/Inner Page/DownloadBanner.jpg'

function DownloadBanner() {
  return (
    <>
      <section className="banner-sc download-banner">
               <section className="banner-slider">
            <div className="home-banner-sc">
              <div className="banner-container">
                <img
                  src={downloadbanner}
                  alt=""
                  aria-hidden="true"
                  className="donwload-banner-image"
                />
                
                {/* Text Overlay on Left Side */}
                <div className="banner-text-overlay">
                  <div className="banner-contents">
                    <h1 className="banner-title">Downloads</h1>
                  </div>
                </div>
              </div>
            </div>
</section>
      </section>
    </>
  );
}

export default DownloadBanner;
